import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  onSwitchSearchBy,
  onChangeBarcodeInput,
  onChangeColumnsInput,
  resetSearchInputs
} from '../../../actions/components/guest-search';

const initialState = {
  searchBy: 'barcode',
  barcodeInput: '',
  columnsInput: ''
};

const onSwitchSearchByHandler = action => ({
  [action.toString()]: (state, { payload: searchBy }) =>
    set('searchBy', searchBy, state)
});

const onChangeBarcodeInputHandler = action => ({
  [action.toString()]: (state, { payload: barcodeInput }) =>
    set('barcodeInput', barcodeInput, state)
});

const onChangeColumnsInputHandler = action => ({
  [action.toString()]: (state, { payload: columnsInput }) =>
    set('columnsInput', columnsInput, state)
});

const resetSearchInputsHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    barcodeInput: '',
    columnsInput: ''
  })
});

export default createReducer(initialState, {
  ...onSwitchSearchByHandler(onSwitchSearchBy),
  ...onChangeBarcodeInputHandler(onChangeBarcodeInput),
  ...onChangeColumnsInputHandler(onChangeColumnsInput),
  ...resetSearchInputsHandler(resetSearchInputs)
});
